import { render, staticRenderFns } from "./RequestTypeDisclaimer.vue?vue&type=template&id=217d7328&scoped=true"
import script from "./RequestTypeDisclaimer.vue?vue&type=script&lang=js"
export * from "./RequestTypeDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./RequestTypeDisclaimer.vue?vue&type=style&index=0&id=217d7328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217d7328",
  null
  
)

export default component.exports